var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-container"},[_c('ul',_vm._l((this.provision.children),function(child){return _c('li',{key:child.location},[_vm._v(" "+_vm._s(child.text.passages[0].text)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }